import { IconButton, Stack, Badge, Popover, Box, TextField, MenuItem } from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import { useEffect, useState } from "react";
import api from "../services/api";


export default function CategoriaFilter(props) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [classeEstabelecimentos, setClasseEstabelecimentos] = useState([]);
  const open = Boolean(anchorEl);

  const onClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    // Buscar categorias de estabelecimentos
    api
      .get("/tipo-estabelecimentos")
      .then((res) => {
        setClasseEstabelecimentos(res.data.tipoEstabelecimentos);
      })
      .catch((err) => console.error("Erro ao carregar categorias:", err));
  }, []);

  return (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      <IconButton
        size="small"
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        <Badge
          color="primary"
          variant="dot"
          invisible={!props.tipo}
        >
          <FilterListIcon fontSize="small" />
        </Badge>
      </IconButton>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={onClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Box p={2} minWidth={220}>
        <TextField
          style={{ width: 200 }}
          select
          size="small"
          variant="outlined"
          onChange={(e) =>
            props.setTipo(e.target.value === "Categorias" ? "" : e.target.value)
          }
          value={props.tipo}
          label="Categorias"
          // defaultValue="Categorias"
        >
          <MenuItem value="Categorias">Categorias</MenuItem>
          {classeEstabelecimentos?.map((classeEstabelecimento) => (
            <MenuItem
              key={classeEstabelecimento._id}
              value={classeEstabelecimento._id}
            >
              {classeEstabelecimento?.designacao?.toUpperCase()}
            </MenuItem>
          ))}
        </TextField>
        </Box>
      </Popover>
    </Stack>
  );
};


